import { Injectable } from '@angular/core';
import {
  appClientMetaToHttpHeaders,
  collectAppClientMeta,
} from '@core/utils/app-client-meta.util';

@Injectable({
  providedIn: 'root',
})
export class AppClientMetaService {
  private httpHeaders: Record<string, string> = {};
  private loadPromise: Promise<void> | null = null;

  /** Cache device/app info for API headers (Capacitor native; partial on web). */
  ensureLoaded(): Promise<void> {
    if (!this.loadPromise) {
      this.loadPromise = collectAppClientMeta().then((meta) => {
        this.httpHeaders = appClientMetaToHttpHeaders(meta);
      });
    }
    return this.loadPromise;
  }

  getHttpHeaders(): Record<string, string> {
    return this.httpHeaders;
  }
}
